/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopicMessagePhase
 */
export interface TopicMessagePhase {
    /**
     * 
     * @type {string}
     * @memberof TopicMessagePhase
     */
    name?: string;
}

export function TopicMessagePhaseFromJSON(json: any): TopicMessagePhase {
    return TopicMessagePhaseFromJSONTyped(json, false);
}

export function TopicMessagePhaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopicMessagePhase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TopicMessagePhaseToJSON(value?: TopicMessagePhase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

